// extracted by mini-css-extract-plugin
export default {"adMessage":"C4jzN","adMessageText":"i4vzG","adMessageProgressBar":"uN6BM","adMessageSequence":"BqsO3","adMessageDot":"dvYfh"};